import { onCLS, onFID, onLCP } from 'web-vitals'

const reportWebVitals = () => {
  onCLS(console.log)
  onFID(console.log)
  onLCP(console.log)
}

export default reportWebVitals
